import { render } from "./ButtonLabel.vue?vue&type=template&id=01cc2e1d&scoped=true&ts=true"
import script from "./ButtonLabel.vue?vue&type=script&lang=ts"
export * from "./ButtonLabel.vue?vue&type=script&lang=ts"

import "./ButtonLabel.vue?vue&type=style&index=0&id=01cc2e1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cc2e1d"]])

export default __exports__